<template>
<CContainer>
    <CRow>
        <CCol col="12" class="d-flex overflow-auto px-0">
            <CheckoutFilterIt />
        </CCol>
    </CRow>
    <CheckoutListTable class="mt-2" />
</CContainer>
</template>

<script>
import { mapActions } from 'vuex'
import { CheckoutListTable, CheckoutFilterIt } from './partials'

export default {
    name: 'PublishersCheckoutList',

    components: {
        CheckoutListTable,
        CheckoutFilterIt,
    },

    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.publishersCheckoutList({
                no_paginate: true
            })
        })
    },

    methods: {
        ...mapActions({
            publishersCheckoutList: 'wallet/publishersCheckoutList',
        }),
    }
}
</script>